exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".photo-wrapper[data-v-a812ac4c]{border:1px solid #fff;border-radius:10px;border-style:dashed;overflow:hidden;cursor:pointer}.photo-wrapper i[data-v-a812ac4c]{margin:auto}.photo-wrapper img[data-v-a812ac4c]{width:100%}", ""]);

// exports
